// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh3[data-v-accc41fc] {\n  font-weight: 500;\n  background-color: #00747b;\n  padding-left: 10px;\n  color: white;\n}\nh4[data-v-accc41fc] {\n  font-weight: 600;\n  background-color: #c1c7b0;\n  padding-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
